import React from "react";

interface Props {
  title: string;
  children: React.ReactNode;
}

const PanelCard: React.FC<Props> = ({ title, children }) => {
  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 className="text-base font-semibold text-black dark:text-white">
          {title}
        </h3>
      </div>

      <div className="p-6">
        {children}
      </div>

    </div>
  );
};

export default PanelCard;